/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { WellContextService } from '@well/infra/logged-in-context';
import { map, withLatestFrom } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ErrorSeverityEnum } from '@irian-ro/shared-components-module';

export const isServiceProviderGuard: CanActivateFn = () => {
  const translate = inject(TranslateService);
  const context = inject(WellContextService);
  const message = inject(MessageService);

  const errorMessage = translate.stream('generalErrors.isNotServiceProvider');

  return context.getLoggedInContext().pipe(
    withLatestFrom(errorMessage),
    map((res) => {
      const [data, errorMessage] = res;
      message.add({
        summary: errorMessage,
        severity: ErrorSeverityEnum.error,
        sticky: true,
      });
      return data.serviceProvider;
    })
  );
};
